<div class="table-scroll-wrapper">
  <table class="navinta-table">
    <thead>
      <tr>
        <th class="col-10" i18n="@@productList.productTable.column1.header" data-testid="productList.productTable.column1">
          Pos.
        </th>
        <th class="col-18" i18n="@@productList.productTable.column2.header" data-testid="productList.productTable.column2">
          Anzahl
        </th>
        <th class="col-auto" i18n="@@productList.productTable.column3.header" data-testid="productList.productTable.column3">
          Bezeichnung
        </th>
        <th class="col-20" i18n="@@productList.productTable.column4.header" data-testid="productList.productTable.column4">
          Sachnummer
        </th>
        <th class="col-15" i18n="@@productList.productTable.column5.header" data-testid="productList.productTable.column5">
          Einzelpreis
        </th>
        <th
          class="col-15"
          i18n="@@productList.productTable.column.discounts"
          data-testid="productList.productTable.column.discounts"
        >
          Rabatt
        </th>
        <th class="col-15" i18n="@@productList.productTable.column6.header" data-testid="productList.productTable.column6">
          Gesamtpreis
        </th>
      </tr>
    </thead>
    <tbody>
      @for (instruction of attachmentInstructions; track $index) {
        <tr [ngClass]="{ discontinued: !instruction.isAvailable, incomplete: instruction.isIncompleteConfiguration }">
          <td>
            {{ instruction.positionId + (instruction.isAvailable || !instruction.isIncompleteConfiguration ? "" : " ") }}
            @if (!instruction.isAvailable || instruction.isIncompleteConfiguration) {
              <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
            }
          </td>
          <td>{{ 1 }}</td>
          <td>{{ instruction.name }}</td>
          <td>{{ instruction.id }}</td>
          <td>
            @if (showZrefPrices) {
              {{
                !showCosts || !instruction.zrefPriceData
                  ? ""
                  : (getUnitPrice(instruction) | currency: instruction.zrefPriceData.currencyCode)
              }}
            } @else {
              {{
                !showCosts || !instruction.priceData
                  ? ""
                  : (getUnitPrice(instruction) | currency: instruction.priceData!.currencyCode)
              }}
            }
          </td>
          <td>
            @if (hasEditablePrice(instruction)) {
              <div class="product-table-attachment-instructions__discount-input">
                <input
                  type="text"
                  inputmode="decimal"
                  [value]="formatDiscount(instruction.discount ?? 0)"
                  [attr.aria-label]="'Discount ' + instruction.name"
                  (blur)="normalizeDiscountInput($any($event.target), instruction)"
                />
                <span aria-hidden="true">%</span>
              </div>
            } @else if (hasPrice(instruction) && instruction.discount) {
              {{ formatDiscount(instruction.discount) }}%
            } @else if (hasPrice(instruction) && instruction.discountKey) {
              -
            }
          </td>
          <td>
            @if (showZrefPrices) {
              {{
                !showCosts || !instruction.zrefPriceData
                  ? ""
                  : (getTotalPrice(instruction) | currency: instruction.zrefPriceData.currencyCode)
              }}
            } @else {
              {{
                !showCosts || !instruction.priceData
                  ? ""
                  : (getTotalPrice(instruction) | currency: instruction.priceData!.currencyCode)
              }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
